import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 진단점검하기 컴포넌트
 *
 ********************************************************************/
import { useRecoilValue } from "recoil";
import { checkTypeState } from "../../../../recoil/assessmentState";
import CheckHeader from "./CheckHeader";
import CheckList from "./step/CheckList";
import CheckPreviousInspection from "./step/CheckPreviousInspection";
import CheckReslut from "./step/CheckReslut";
import CheckStep1 from "./step/CheckStep1";
import CheckStep2 from "./step/CheckStep2";
import CheckStep3 from "./step/CheckStep3";
function CheckMain(props) {
    // recoil
    const check = useRecoilValue(checkTypeState);
    // porps
    const { handleOpenPop } = props;
    return (_jsxs(_Fragment, { children: [_jsx(CheckHeader, { handleOpenPop: handleOpenPop }), check.nextStep == "step1" ? (_jsx(CheckStep1, {})) : check.nextStep == "step2" ? (_jsx(CheckStep2, {})) : check.nextStep == "step3" ? (_jsx(CheckStep3, { handleOpenPop: handleOpenPop })) : check.nextStep == "prelist" ? (_jsx(CheckPreviousInspection, {})) : check.assessmentId > 0 && check.nextStep == "checkList" ? (_jsx(CheckList, { handleOpenPop: handleOpenPop })) : (check.assessmentId > 0 && check.nextStep == "result" && _jsx(CheckReslut, { handleOpenPop: handleOpenPop }))] }));
}
export default CheckMain;
